import _classCallCheck from "/var/www/riseup-pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/riseup-pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/www/riseup-pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/var/www/riseup-pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _extends from '../polyfills/extends';
import React from 'react';
import PropTypes from 'prop-types';
import NimbleEmoji from './emoji/nimble-emoji';
var NotFound = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(NotFound, _React$PureComponent);
  var _super = _createSuper(NotFound);
  function NotFound() {
    _classCallCheck(this, NotFound);
    return _super.apply(this, arguments);
  }
  _createClass(NotFound, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        data = _this$props.data,
        emojiProps = _this$props.emojiProps,
        i18n = _this$props.i18n,
        notFound = _this$props.notFound,
        notFoundEmoji = _this$props.notFoundEmoji;
      var component = notFound && notFound() || React.createElement('div', {
        className: 'emoji-mart-no-results'
      }, NimbleEmoji(_extends({
        data: data
      }, emojiProps, {
        size: 38,
        emoji: notFoundEmoji,
        onOver: null,
        onLeave: null,
        onClick: null
      })), React.createElement('div', {
        className: 'emoji-mart-no-results-label'
      }, i18n.notfound));
      return component;
    }
  }]);
  return NotFound;
}(React.PureComponent);
export { NotFound as default };
NotFound.propTypes /* remove-proptypes */ = {
  notFound: PropTypes.func.isRequired,
  emojiProps: PropTypes.object.isRequired
};